import { BorderGridContainer, GridBox } from '@ahmdigital/ui';
import { isEmpty } from 'lodash/fp';
import styled from 'styled-components';

import Banner from '../../../elements/banner';
import constants from '../../../ahm-constants';
import CONTENT from './content';
import Head from '../../../../utils/head';
import InsuranceSection from '../components/section';
import RedirectAdapter from '../../../utils/redirect-adapter';

type LifeInsuranceClaimPageProps = {
  insuranceType: string;
};

const StyledInsuranceSection = styled(InsuranceSection)`
  padding-bottom: 8rem;
`;

const FULL_WIDTH_COLS = 12;

const LifeInsuranceClaimPage = ({ insuranceType }: LifeInsuranceClaimPageProps) => {
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ 'income-protection': () => { meta: { title: string; description: string; }; banner: { title: string; preHeading: string; }; body: Element; thingsYouShouldKnow: Element; }; life: () => { ...; }; }'.
  const content = CONTENT?.[insuranceType]();

  if (isEmpty(content)) {
    return <RedirectAdapter to={constants.URLS.SALES.ERROR_404} />;
  }

  const meta = content?.meta;

  return (
    <>
      <Head titleTemplate="%s - ahm insurance">
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
      </Head>
      <BorderGridContainer hideBorderTop>
        {content?.banner && <Banner {...content.banner} />}
        <GridBox padding="0">
          <StyledInsuranceSection dfContentCols={FULL_WIDTH_COLS}>
            {content?.body && content.body}
          </StyledInsuranceSection>
        </GridBox>
      </BorderGridContainer>
    </>
  );
};

export default LifeInsuranceClaimPage;
